import { DATAGRID_TABLE_CELL_WIDTH } from '../../utils/constants';

const columns = (renderCell, renderActions) => [
  {
    field: 'email',
    headerName: 'User Email',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params) => params.row.email === 'all_users' ? 'All Users' : params.row.email,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  },
];
export default columns;
